import React, { useEffect, useState } from "react";
import { getDirectusClient } from "../../../lib/directus";
import { Button, Form, Input, Modal, Space } from "antd";
import { useForm } from "antd/es/form/Form";
import { readItems } from "@directus/sdk";
import { useSelector } from "react-redux";
import { truncateSerial } from "../../../lib/utils";

function Caja(props) {
  const arrayp = props.productosagregados;
  const [seriales, setSeriales] = useState([]);
  const userBodega = useSelector((state) => state.userdata.bodega?.id);
  const userRoleID = useSelector((state) => state.userdata.role?.name);
  const omitir1 = useSelector((state) => state.omitir1.omitir1);
  const [productos, setProductos] = useState([]);
  const [form] = useForm();

  const onFinish = async (values) => {
    const directus = await getDirectusClient();

    const cajaYaAgregada = arrayp.some(
      (item) => !item.isNonSerialized && item.caja === values.caja
    );

    if (cajaYaAgregada) {
      Modal.warning({
        title: "Caja ya agregada",
        content: `La caja ${values.caja} ya ha sido agregada al préstamo. No se puede agregar la misma caja dos veces.`,
      });
      return;
    }

    await directus
      .request(
        readItems("seriales", {
          fields: [
            "serial",
            "id",
            "producto.nombre",
            "producto.preciosinimp",
            "producto.grupo.impuesto",
            "producto.id",
            "estado.id",
            "estado.estado",
          ],
          filter: {
            caja: truncateSerial(values.caja, omitir1),
            estado: 1,
            ...(userRoleID !== "adminapp" && userRoleID !== "Administrator"
              ? {
                  bodega: {
                    id: { _eq: userBodega },
                  },
                }
              : {}),
          },
          limit: -1,
        })
      )
      .then((res) => {
        if (res.length <= 0) {
          Modal.error({
            title:
              "No se encontraron seriales activos con los datos suministrados",
          });
          return;
        }

        const serialesYaAgregados = res.filter((item) =>
          arrayp.some(
            (existingItem) =>
              !existingItem.isNonSerialized &&
              existingItem.serial === item.serial
          )
        );

        const serialesNuevos = res.filter(
          (item) =>
            !arrayp.some(
              (existingItem) =>
                !existingItem.isNonSerialized &&
                existingItem.serial === item.serial
            )
        );

        if (serialesYaAgregados.length > 0) {
          const serialesDuplicados = serialesYaAgregados
            .map((item) => item.serial)
            .join(", ");
          Modal.info({
            title: "Algunos seriales ya agregados",
            content: `Los siguientes seriales ya han sido agregados al préstamo: ${serialesDuplicados}. Se agregarán solo los seriales nuevos.`,
          });
        }

        if (serialesNuevos.length === 0) {
          Modal.warning({
            title: "No hay seriales nuevos",
            content:
              "Todos los seriales de esta caja ya han sido agregados al préstamo.",
          });
          return;
        }

        setSeriales(serialesNuevos);
        // Append new serialized items with isNonSerialized: false
        const newItems = serialesNuevos.map((item) => ({
          ...item,
          isNonSerialized: false,
        }));
        props.setProductosagregados((prev) => [...prev, ...newItems]);
      })
      .catch((err) => console.log(err));

    console.log("Success:", values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  useEffect(() => {}, [arrayp]);

  return (
    <>
      {props.productosagregados.length}
      <Form
        form={form}
        name="basic"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        style={{ maxWidth: 600 }}
        initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Space size="large" direction="vertical" style={{ display: "flex" }}>
          <Form.Item
            wrapperCol={{ offset: 8, span: 16 }}
            label="Caja"
            name="caja"
            rules={[{ required: true, message: "Please input your caja!" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            wrapperCol={{
              offset: 8,
              span: 16,
            }}
          >
            <Button type="primary" htmlType="submit">
              procesar
            </Button>
          </Form.Item>
        </Space>
      </Form>
    </>
  );
}

export default Caja;
